// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const DefaultDocument: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16">
            <path
                fill="currentColor"
                d="M8,0 L8,4 L12,4 L8,0 Z M7,4 L7,0 L1.5,0 C0.671562672,0 0,0.671562195 0,1.5 L0,14.5 C0,15.328125 0.671562672,16 1.5,16 L10.5,16 C11.3284378,16 12,15.3284378 12,14.5 L12,5 L8.02812481,5 C7.4468751,5 7,4.55312538 7,4 Z"
            />
        </svg>
    );
};

export default React.memo(DefaultDocument);
